import { createStore, createEffect, createEvent, combine } from 'effector';
import { $notificationStore } from '../notificationStore';
import { TransferRequestsApi, type TransferRequestCreateDocumentRequest } from '@shared/api';

const createDocumentEffect = createEffect((request: TransferRequestCreateDocumentRequest) => TransferRequestsApi.createDocument(request));
const clearEvent = createEvent();

const $dataStore = createStore<string>('')
  .on(createDocumentEffect.done, (_, values) => values.result.data)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(createDocumentEffect.pending, (_, data) => data)
  .on(createDocumentEffect.fail, () => false)
  .on(createDocumentEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(createDocumentEffect, () => null)
  // .on(effect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(createDocumentEffect.fail, () => 'Something went wrong while creating Document. Please try again.')
  .on(createDocumentEffect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((x) => $notificationStore.events.setError(x));

export const $transferRequestsUploadFileStore = {
  events: {
    createDocument: createDocumentEffect,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
